export default __webpack_public_path__ + "static/Fitnessraum-a70705f60a9d7e7033571cdf04a11d4d.pdf";